import type {
    ReportDeviceMaintenanceScheduleResponse,
    ReportPerformanceResponse,
    ReportProductionComparisonResponse,
    ReportSparePartReplacementRateResponse,
} from '@/types/apps/report-v2.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';

export class ReportV2Service {
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        performanceReport: () => '/api/v2/reports/performance-report',
        productionComparison: () => '/api/v2/reports/production-comparison',
        sparePartReplacementRate: () =>
            '/api/v2/reports/spare-part-replacement-rate',
        deviceMaintenanceSchedule: () =>
            '/api/v2/reports/device-maintenance-schedule',
        exportPeformanceReport: () =>
            '/api/v2/reports/device-performance/export',
        exportProductionComparison: () =>
            '/api/v2/reports/production-comparison/export',
        exportSparePartReplacementRate: () =>
            '/api/v2/reports/sparepart-replacement/export',
        exportDeviceMaintenanceSchedule: () =>
            '/api/v2/reports/device-maintenance-schedule/export',
    };

    public getPerformanceReport(
        params?: QueryParams
    ): Promise<ApiResponse<PaginatedResult<ReportPerformanceResponse>>> {
        return this.apiClient.fetchApi(
            this.endpoints.performanceReport(),
            params
        );
    }

    public getProductionComparison(
        params?: QueryParams
    ): Promise<
        ApiResponse<PaginatedResult<ReportProductionComparisonResponse>>
    > {
        return this.apiClient.fetchApi(
            this.endpoints.productionComparison(),
            params
        );
    }

    public getSparePartReplacementRate(
        params?: QueryParams
    ): Promise<
        ApiResponse<PaginatedResult<ReportSparePartReplacementRateResponse>>
    > {
        return this.apiClient.fetchApi(
            this.endpoints.sparePartReplacementRate(),
            params
        );
    }

    public getDeviceMaintenanceSchedule(
        params?: QueryParams
    ): Promise<
        ApiResponse<PaginatedResult<ReportDeviceMaintenanceScheduleResponse>>
    > {
        return this.apiClient.fetchApi(
            this.endpoints.deviceMaintenanceSchedule(),
            params
        );
    }

    public async exportPerformanceReport(params?: QueryParams): Promise<Blob> {
        return this.apiClient.fetchBlob(
            this.endpoints.exportPeformanceReport(),
            params
        );
    }

    public async exportProductionComparison(
        params?: QueryParams
    ): Promise<Blob> {
        return this.apiClient.fetchBlob(
            this.endpoints.exportProductionComparison(),
            params
        );
    }

    public async exportSparePartReplacementRate(
        params?: QueryParams
    ): Promise<Blob> {
        return this.apiClient.fetchBlob(
            this.endpoints.exportSparePartReplacementRate(),
            params
        );
    }

    public async exportDeviceMaintenanceSchedule(
        params?: QueryParams
    ): Promise<Blob> {
        return this.apiClient.fetchBlob(
            this.endpoints.exportDeviceMaintenanceSchedule(),
            params
        );
    }
}
